<template>
<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none" stroke="none">
    <ellipse cx="16.0614" cy="16" rx="16.0614" ry="16" :fill="secundaryColor"/>
    <ellipse cx="16.0617" cy="16" rx="12.0461" ry="12" :stroke="primaryColor" stroke-width="1.2"/>
    <g clip-path="url(#clip0_16302_305445)">
        <path d="M16.0634 9.3335L18.1313 13.5068L22.7556 14.1802L19.4095 17.4268L20.1992 22.0135L16.0634 19.8468L11.9275 22.0135L12.7172 17.4268L9.37109 14.1802L13.9954 13.5068L16.0634 9.3335Z" :stroke="starColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_16302_305445">
        <rect width="16.0614" height="16" fill="white" transform="translate(8.03125 8)"/>
        </clipPath>
    </defs>
</svg>
</template>

<script>
export default {
    props: {
        primaryColor: {
            required: false,
            type: String,
            default: '#6D85FD'
        },
        secundaryColor:{
            required: false,
            type: String,
            default: '#E7EBFF'
        },
        starColor: {
            required: false,
            type: String,
            default: '#3D5DFC'
        }
    }
}
</script>
